import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getNotifications = async ({
  companyCode,
  fromDate,
  toDate,
  userId,
  status = "ALL",
}) => {
  let queryString = `&FromDate=${fromDate}&Todate=${toDate}`;

  if (status !== "ALL") {
    queryString += `&Status=${status}`;
  }

  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetNotifications}?CompanyCode=${companyCode}&UserID=${userId}${queryString}
`,
  );
  // &FromDate=${fromDate}&Todate=${toDate}
  return data;
};

const updateNotification = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.UpdateNotification,
    input,
  );
  return data;
};

const clearAllNotifications = async (input) => {
  const { data } = await http_payroll.put(
    Api_EndPoints.ClearAllNotifications,
    input,
  );
  return data;
};
export const useGetAllNotificationsQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetNotifications],
    queryFn: () => getNotifications(input),
  });
};

export const useUpdateNotificationMutation = () => {
  return useMutation({
    mutationFn: updateNotification,
  });
};

export const useClearAllNotificationsMutation = () => {
  return useMutation({
    mutationFn: clearAllNotifications,
  });
};
